import React from "react";
import { useRouter } from "next/router";
import { useDetectAdBlock } from "adblock-detect-react";

import Logo from "./Logo";
import { LoadingButton } from "@mui/lab";
import { Button, Grow } from "@mui/material";

const PUBLIC_PATHS = [
  "/",
  "/profile",
  "/helpme",
  "/register",
  "/reset-password",
];

export default function OverlayAdBlocker() {
  const router = useRouter();
  const adBlockDetected = useDetectAdBlock();
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (adBlockDetected && !PUBLIC_PATHS.includes(router.pathname)) {
      setShow(true);
      console.log("ad block detected");
    }
  }, [adBlockDetected, router.pathname]);

  const handleClick = () => {
    router.reload();
  };

  const handleCancel = () => {
    setShow(false);
    router.push({
      pathname: "/helpme",
      query: {
        status: "adBlocker",
        redirect: "https://trychannel.ai",
      },
    });
  };

  return (
    <Grow in={show} direction="up">
      <div className="absolute inset-0 bg-white/95 z-50 whitespace-pre-wrap">
        <div className="max-w-3xl mx-auto text-center space-y-5 px-2">
          <div className="w-32 mx-auto mb-[15%]">
            <Logo />
          </div>
          <h1 className="text-6xl">🤓</h1>
          <h1>Oh oh... looks like you have an Ad Blocker</h1>
          <p className="text-[#7E7E7E] leading-relaxed pb-20">
            {
              "If you want the best product experience we kindly ask you to shut off your ad blocker while you complete this brief. We will not be showing you any ads, we promise!"
            }
          </p>
          <div className="flex flex-col items-center">
            <LoadingButton
              onClick={handleClick}
              sx={{ width: "214px", height: "72px" }}
            >
              {"Refresh"}
            </LoadingButton>
            <Button variant="text" onClick={handleCancel}>
              {"Can't seem to make it work."}
            </Button>
          </div>
        </div>
      </div>
    </Grow>
  );
}
